// removed by extract-text-webpack-plugin
module.exports = {"quote":"src-components-Quote----quote-module---quote---1oeoC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Quote/quote.module.sass
// module id = 365
// module chunks = 195351340454287